const csvTemplate = `action,customer_code,user
add,SBY1-11155,john.doe@example.com
remove,SBY1-11155,jane.smith@example.com`;

export default csvTemplate;
